import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'src/app-redux/rtkq.interceptor';
import { partnersTag } from 'src/app-redux/rtkq.tags';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import { apiResources } from 'src/common/Constants';
import { User } from 'src/management/User';

/** RTK Query API slice for partner management endpoints. */
export const partnersApi = createApi({
  reducerPath: 'partnersApi',
  tagTypes: [partnersTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch partners with pagination and search parameters. */
    getPartners: builder.query<User[], { page: number; searchParam: { [id: string]: string } }>({
      providesTags: [partnersTag],
      query: (args) => {
        return {
          url: apiResources.partners,
          params: { page: args.page, ...args.searchParam },
          method: 'GET',
        };
      },
      ...transformResponses,
    }),
  }),
});

/** RTK Query hooks for partner management endpoints. */
export const { useGetPartnersQuery, useLazyGetPartnersQuery } = partnersApi;
